import React, { useState, useEffect } from 'react';
import "./ImportInstitution.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { uploadInstitutionFile, getInstitutions, downloadInstitutionFile } from '../../services/http';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import ImportContent from '../../components/ImportContent/ImportContent';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Navbar from '../../appShell/Navbar/Navbar';


const ImportInstitution = () => {

    const navigate = useNavigate()

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showError, setShowError] = useState(false)
    const [processOngoing, setProcessOngoing] = useState(false)


    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);

    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Institutions", secondLevelLink: "/institution", thirdLevelText: "Import", thirdLevelLink: "/import-institution"
            }
        });

        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("institutions", dispatch)
    }, [])


    const handleImportData = async (e) => {
        setProcessOngoing(true)
          //Start
        // End
        if (states.selectedFile != null) {
            const req = await uploadInstitutionFile(states.selectedFile, states.userToken.access_token)
        if (req.response && req.response.status !== 200) {
            setProcessOngoing(false)
            if (req.response && req.response.status == 422) {
                var errorMsg = `Import partiellement effectué. Les lignes ${Object.keys(req.response?.data)} sont incorrectes.`;
                    toast.warning(errorMsg, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                let response = await getInstitutions(states.userToken.access_token, 1, "");

                let response_copy = response.data?.data.map(obj => ({ ...obj, showDelete: false }))

                dispatch({
                    type: "SET",
                    key: "institutionList",
                    payload: response_copy,
                });
            } else if(req.response && req.response.status == 400) {
                setProcessOngoing(false)
                toast.error(req.response?.data, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else if(req.status == 200) {
            setProcessOngoing(false)
            toast.success(req?.data, {
                position: toast.POSITION.TOP_RIGHT
            });
            let response = await getInstitutions(states.userToken.access_token, 1, "");

            let response_copy = response.data?.data.map(obj => ({ ...obj, showDelete: false }))

            dispatch({
                type: "SET",
                key: "institutionList",
                payload: response_copy,
            });


        }} else {
            setProcessOngoing(false)
            toast.warning(`Veuillez sélectionner un fichier.`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }

    }
    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing mb-4">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <div className="row pl-3 mt-2">
                            <button className="btn btn-rounded mb-2 mr-2" onClick={() => { navigate("/institution") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
                        </div>
                        <ImportContent processOngoing={processOngoing} downloadRequest={downloadInstitutionFile} fileName={"institutions"} type={" institutions "} handleImportData={handleImportData} />
                    </div>

                </div>
            </div>
        </div>


    )
}

export default ImportInstitution


